
export interface PolygonOptions {
    clickable?: boolean;
}

